import { HttpClient } from '@angular/common/http';
import { Injector, NgModule } from '@angular/core';
import { SettingsService } from '@common-modules/shared/config/settings.service';
import { BASE_API_URL } from './generated-client.token';
import { InstancesRegisterService } from './services/instances-register.service';
import { WorkOrdersElementService } from './services/work-orders-element.service';

@NgModule({
  declarations: [],
  imports: [],
  exports: [],
  providers: [
    InstancesRegisterService,
    WorkOrdersElementService,
    {
      provide: BASE_API_URL,
      useFactory: (settingsService: SettingsService) => settingsService.apis.default.url,
      deps: [SettingsService],
    },
    { provide: 'HttpClient', useExisting: HttpClient },
  ],
})
export class TCGeneratedClientModule {
  static injector: Injector;

  constructor(injector: Injector) {
    TCGeneratedClientModule.injector = injector;
  }
}
